import { EnumAboutUsType } from '@xt/client/enums/home/index'

export const dataSource_AboutUsEntry: Array<{
  key: EnumAboutUsType
  name: string
  icon: string
  path?: string
}> = [
  {
    key: EnumAboutUsType.Classroom,
    name: '暄桐教室',
    icon: 'layout-footer-classroom.svg',
    path: '/about-xuantong'
  },
  {
    key: EnumAboutUsType.Wenfang,
    name: '暄桐文房',
    icon: 'layout-footer-wenfang.svg'
  },
  {
    key: EnumAboutUsType.Art,
    name: '山林曦照',
    icon: 'layout-footer-art-v3.png'
  },
  {
    key: EnumAboutUsType.World,
    name: '林曦的小世界',
    icon: 'layout-footer-world.svg'
  }
]
